import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function HeaderMobileActions() {
  return <div className="flex lg:hidden items-center space-x-2" data-id="element-2715">
      <a href="tel:2483800871" className="text-navy p-2" aria-label="Call Peak Machine Sales" data-id="element-2716">
        <PhoneIcon className="w-5 h-5" data-id="element-2717" />
      </a>
      <Button variant="primary" href="/ContactPeakMachineSales.html" size="md" className="text-xs px-3 py-2" data-id="element-2718">
        Contact
      </Button>
    </div>;
}